// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3IH3-","itemTitle":"ClientEmergencyInfo_itemTitle__2HvYY","itemText":"ClientEmergencyInfo_itemText__133nh"};